import { Button } from 'antd';
import styled from 'styled-components';

export const StyledQuickAction = styled(Button)`
	.delete {
		position: absolute;
		top: -5px;
		right: -5px;
		font-size: 18px;
		background: var(--green);
		color: var(--white);
		border: none;
		padding: 1px;
		border-radius: 18px;
		opacity: 0;
		transition:
			opacity 0.3s,
			background-color 0.3s;

		&:not(:disabled):not(.ant-btn-disabled):hover {
			background-color: var(--red);
			color: var(--white);
		}

		span {
			display: block;
		}
	}

	&:hover .delete {
		opacity: 1;
	}
`;
